import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import {  SearchSpacer } from "src/components/common/common";
import { SubtotalControl } from "./components/SubtotalControl";
import usePUR5010_R01Store, { defaultPUR5010_R01Filter } from "./Store_PUR5010_R01";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

export const SearchSection_PUR5010_R01 = () => {
    const {
        PUR5010_R01Filter,
        setPUR5010_R01Filter,
    } = usePUR5010_R01Store();

    const {
        brandCdList,         //  브랜드 공통코드
        itemAccountList,
        itemGroupList,
        wmsCdList,
        warehouseCdList
    } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

	const handleItemFoucsId = 'itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목',
			focusId: handleItemFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			searchFunction: async (searchText: string) => {
				const itemResponse = await getItemPopupList(searchText, '', '', '');
				return itemResponse.data.data.find(value => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: PUR5010_R01Filter.itemCd || '',
				itemNm: PUR5010_R01Filter.itemNm || '',
			}),
		},
	];


	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR5010_R01Filter,
		setEditData: setPUR5010_R01Filter,
		defaultData: defaultPUR5010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR5010_R01_search'
	});
	
    return (
        <div className="w-full">
            <SearchSectionDoubleForm >

                <SearchDropDownForm<SysCodeDto>
                    label="물류센터"
                    value={PUR5010_R01Filter.logicCenter}
                    optionList={wmsCdList}
                    onChangeValue={v => setPUR5010_R01Filter({ logicCenter: v === 'all' ? '' : v })}
                />
                <SearchDropDownForm<WareHouseDto>
                    label="창고코드"
                    value={PUR5010_R01Filter.warehouseCd}
                    optionList={warehouseCdList}
                    onChangeValue={v => setPUR5010_R01Filter({ warehouseCd: v === 'all' ? '' : v })}
                />

                {/* 브랜드 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={PUR5010_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={(v) =>
                        setPUR5010_R01Filter({
                            brandCd: v === "all" ? "" : v,
                        })
                    }
                />


                <SearchSpacer/>

                <SearchDropDownForm<SysCodeDto>
                    label="품목계정"
                    value={PUR5010_R01Filter.itemAccount}
                    optionList={itemAccountList}
                    onChangeValue={(v) =>
                        setPUR5010_R01Filter({
                            itemAccount: v === "all" ? "" : v,
                        })
                    }
                />
                <SearchDropDownForm<SysCodeDto>
                    label="품목그룹"
                    value={PUR5010_R01Filter.itemGroup}
                    optionList={itemGroupList}
                    onChangeValue={(v) =>
                        setPUR5010_R01Filter({
                            itemGroup: v === "all" ? "" : v,
                        })
                    }
                />

                {/* 품목 검색 */}
                <SearchCodeModalForm
                    label="품목코드"
                    value={PUR5010_R01Filter.itemCd}
                    valueLabel={PUR5010_R01Filter.itemNm}
                    handleFoucsId={handleItemFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
                />

                <SubtotalControl />

            </SearchSectionDoubleForm>
        </div>
    );
};
